import PropTypes from "prop-types";

import {
  Box,
  Divider,
  Drawer,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Scrollbar } from "./scrollbar";
import { items } from "./config";
import { SideNavItem } from "./side-nav-item";
import TopNav from "./top-nav";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export const SideNav = (props) => {
  const { open, onClose } = props;
  const pathname = useLocation();
  let userData = useSelector((s) => s.auth?.userData || undefined);
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const user =
    typeof window !== "undefined"
      ? JSON.parse(localStorage.getItem("user"))
      : null;
  const content = (
    <Scrollbar
      sx={{
        backgroundColor: "#fff",
        height: "100%",
        "& .simplebar-content": {
          height: "100%",
        },
        "& .simplebar-scrollbar:before": {
          background: "#FFFFFF",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <Box
          sx={{ p: 3 }}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <img src="img/logo.svg" className="logo-image" />
        </Box>
        <Box
          component="nav"
          sx={{
            flexGrow: 1,
            px: 2,
          }}
        >
          <Stack
            component="ul"
            spacing={0.5}
            sx={{
              listStyle: "none",
              p: 0,
              m: 0,
            }}
          >
            {items.map((item) => {
              if (!item?.approved && userData?.status == "rejected") {
                return false;
              }

              if (
                !item?.approved &&
                userData?.previousStatus?.includes("rejected") &&
                userData?.status !== "approved"
              )
                return false;
              const active = item.path
                ? pathname.pathname.includes(item.path + "/") ||
                  pathname.pathname === item.path
                : false;

              return (
                <SideNavItem
                  active={active}
                  disabled={item.disabled}
                  external={item.external}
                  icon={item.icon}
                  key={item.title}
                  path={item.path}
                  title={item.title}
                />
              );
            })}
          </Stack>
        </Box>
      </Box>
    </Scrollbar>
  );

  if (lgUp) {
    return (
      <Drawer
        anchor="left"
        open
        PaperProps={{
          sx: {
            backgroundColor: "neutral.800",
            color: "common.white",
            width: 280,
          },
        }}
        variant="permanent"
      >
        {content}
      </Drawer>
    );
  }

  return (
    <Drawer
      anchor="left"
      onClose={onClose}
      open={open}
      PaperProps={{
        sx: {
          backgroundColor: "neutral.800",
          color: "common.white",
          width: 280,
        },
      }}
      sx={{ zIndex: (theme) => theme.zIndex.appBar + 100 }}
      variant="temporary"
    >
      {content}
    </Drawer>
  );
};

SideNav.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
};
